<div class="gel__text-center mt-5">
  <h1>{{ errorMessages() }}</h1>
  <h3>
    Click the link to go back in page
    <a class="capitalize" (click)="routeTo()">{{ getPageName }}</a>.
  </h3>
  <!-- <h3 *ngIf="this.routeQuery.previousRoute !== ''">You will be redirected to the page <a [routerLink]="" (click)="routeTo()">{{previousRoute().name}}</a> in {{countdown}}</h3> -->
</div>
